var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-search position-relative"},[_c('main-select',{staticClass:"filter-category text-left",attrs:{"options":_vm.filterOptions,"selectedOption":_vm.isNav ? {value: _vm.filterParams.category} : _vm.selectedOption,"search":true,"summaryRef":"categories"},on:{"clickHandler":_vm.changeCategory}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }